module.exports = __webpack_public_path__ + "img/Equipa_Seg_2.b42bfda8.png";